import React, { Component } from 'react';
import { Menu, Icon } from 'antd';
import { Link } from 'react-router-dom';

export default class DashboardMenuItem extends Component {
  render() {
    return (
      <Menu.Item { ...this.props }>
        <Link to={this.props.path}>
          <Icon type={this.props.iconKey} />
          <span className="nav-text">{this.props.title}</span>
        </Link>
      </Menu.Item>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/common/dashboard_menu_item/dashboard_menu_item.js